import { makeStyles } from '@mui/styles'
import {
  GAINSBORO_BORDER,
  MEDIUM_GRAY,
  MIDNIGHT_EXPRESS,
  NEON_BLUE_LIGHT,
  SILVER_SAND,
  WHITE,
} from '@returnmates/client-core/src/constants/colors'
import { URBANIST } from '@returnmates/ui-core/src/constants/styles/fonts'

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '80px',
  },
  main: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '80px',
  },
  leftPart: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    width: '50%',
    paddingLeft: '65px',
  },
  rightPart: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    width: '50%',
    justifyContent: 'flex-end',
  },
  section: {
    textTransform: 'uppercase',
    fontFamily: URBANIST,
    fontWeight: 700,
    fontSize: 18,
    lineHeight: '21.6px',
    color: MIDNIGHT_EXPRESS,
    marginRight: 8,
  },
  title: {
    textTransform: 'uppercase',
    fontFamily: URBANIST,
    fontWeight: 700,
    fontSize: 18,
    lineHeight: '21.6px',
    color: MEDIUM_GRAY,
  },
  iconContainer: {
    marginRight: 10,
  },
  tabsContainer: {
    display: 'flex',
    height: 35,
    marginLeft: 55,
    borderBottom: `1px solid ${SILVER_SAND}`,
    backgroundColor: WHITE,
  },
  tab: {
    display: 'flex',
    alignItems: 'center',
    padding: '3px 15px',
    width: 'fit-content',
    cursor: 'pointer',
    borderBottom: '5px solid transparent',

    '& > svg': {
      marginRight: 10,
    },
  },
  activeTab: {
    borderBottom: `5px solid ${NEON_BLUE_LIGHT}`,
  },
  tabTitle: {
    fontFamily: URBANIST,
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '19.6px',
    letterSpacing: '0.2px',
    color: MIDNIGHT_EXPRESS,
  },
  tabDataCount: {
    background: GAINSBORO_BORDER,
    borderRadius: 4,
    padding: '3px 4px',
    fontFamily: URBANIST,
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '16.8px',
    marginLeft: 5,
    letterSpacing: '0.2px',
  },

  '@media(max-width: 1024px)': {
    title: {
      marginLeft: 10,
      fontSize: 16,
    },
    leftPart: {
      paddingLeft: 20,
    },
  },
}))

export default useStyles
